import { useState } from 'react';
import useAPI from 'hooks/useAPI';

/**
 * 
 * @returns the functions and state required to handle pagination for the customerbin component
 */
function usePagination({ onPageChange, onRowsPerPageChange }) {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (onPageChange) onPageChange(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = event => {
    console.log("Rows per page changed to:", event.target.value);
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    if (onRowsPerPageChange) onRowsPerPageChange(0, newRowsPerPage);
  };

  return { 
    handleChangePage, 
    handleChangeRowsPerPage,
    page,
    rowsPerPage,
    setPage,
    setRowsPerPage,
  };
}

export default usePagination;